import { render, staticRenderFns } from "./VendorPublisherListView.vue?vue&type=template&id=935d5ef6&scoped=true&"
import script from "./VendorPublisherListView.vue?vue&type=script&lang=js&"
export * from "./VendorPublisherListView.vue?vue&type=script&lang=js&"
import style0 from "./VendorPublisherListView.vue?vue&type=style&index=0&id=935d5ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d5ef6",
  null
  
)

export default component.exports